module.exports = __webpack_public_path__ + "img/bitdigital.c858e282.png";